module.exports = __webpack_public_path__ + "static/img/10.e998978.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/zh/10.png
// module id = 3z5v
// module chunks = 0